import {gsap} from "../LibrariesImport";
export default class SwiperDivision {

	static init() {

		const blocks = document.querySelectorAll('.block-slider-division');

		blocks.forEach( (block)=> {

			const swiperElement = block.querySelector('.slider-division-swiper');
			const swiperElementNav = block.querySelector('.slider-division-swiper-nav');
            const swiperElementNavPrev = block.querySelector('.swiper-pill-nav-prev');
			const swiperElementNavNext = block.querySelector('.swiper-pill-nav-next');
			const follower = block.querySelector('.cursor-follower');

			new Swiper(swiperElement, {
				grabCursor: true,
				spaceBetween: 20,
				slidesPerView: "auto",
				watchOverflow: true,
				navigation: {
					prevEl: swiperElementNavPrev,
					nextEl: swiperElementNavNext,
				},
				on: {
					init: (swiper) => {
						this.toggleNavigation(swiper, swiperElement, swiperElementNav);
					},
					resize: (swiper) => {
						this.toggleNavigation(swiper, swiperElement, swiperElementNav);
					},
					update: (swiper) => {
						this.toggleNavigation(swiper, swiperElement, swiperElementNav);
					},
					touchStart: () => {
						gsap.to(follower, 0.2, {
							scale: 0.2,
							opacity: 0
						});
					},
					touchEnd: () => {
						gsap.to(follower, 0.2, {
							scale: 1,
							opacity: 1
						});
					}
				}
			});

		});

	}

	static toggleNavigation(swiper, container, navigation){
		if (swiper.slides.length <= swiper.params.slidesPerView) {
			container.closest('.cursor-follower-inner').classList.add("swiper-disabled-follower");
			navigation.style.display = 'none';
		}else{
			container.closest('.cursor-follower-inner').classList.remove("swiper-disabled-follower");
			navigation.style.display = 'inline-flex';
		}
	}

}